import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseService } from '../infra/base-service';
import { ToastrService } from 'ngx-toastr';
import { Saldo } from '../interfaces/saldo/saldo.interface';
import { BehaviorSubject } from 'rxjs';
import { environment } from '../environments/environment';

interface SaldoComTempo extends Saldo {
  tempo: number;
}

@Injectable({
  providedIn: 'root',
})
export class SaldoService extends BaseService {
  private readonly STORAGE_KEY = 'saldo';
  private readonly TEMPO_EXPIRACAO = environment.tempoExpiracaoCacheSaldoMinutos * 60 * 1000;
  private saldoAtual: BehaviorSubject<SaldoComTempo>;
  private saldoInicial: SaldoComTempo = {
    quantidade: 0,
    motivo: 0,
    mensagemMotivoSaldo: '',
    tempo: 0,
    tipo: '',
  };

  constructor(http: HttpClient, toastr: ToastrService) {
    super(http, toastr);
    this.saldoAtual = new BehaviorSubject<SaldoComTempo>(this.saldoInicial);
  }

  private salvarSaldoToStorage(saldo: SaldoComTempo): void {
    localStorage.setItem(this.STORAGE_KEY, JSON.stringify(saldo));
  }

  private saldoExpirado(timestamp: number): boolean {
    const agora = Date.now();
    return agora - timestamp > this.TEMPO_EXPIRACAO;
  }

  atualizarSaldo(saldo: Saldo): void {
  if (saldo !== null && saldo !== undefined) {
    const saldoComTempo: SaldoComTempo = {
      ...saldo,
      tempo: Date.now(),
    };
    this.saldoAtual.next(saldoComTempo);
    this.salvarSaldoToStorage(saldoComTempo);
  }
}
  resetarSaldo(): void {
    localStorage.removeItem(this.STORAGE_KEY);
    this.saldoAtual.next({ ...this.saldoInicial });
  }

  async obterSaldo(): Promise<Saldo> {
    try {
      const saldo = await this.get<Saldo>('listadecontato/saldo');
      if (saldo !== null && saldo !== undefined) {
        this.atualizarSaldo(saldo);
        return saldo;
      }
      throw new Error('Resposta de saldo inválida');
    } catch (error) {
      console.error('Erro ao obter saldo:', error);
      const saldoAtual = this.saldoAtual.getValue();
      if (saldoAtual) {
        return saldoAtual;
      }
      throw error;
    }
  }

  async obterSaldoAtual(): Promise<Saldo> {
    const saldoAtual = this.saldoAtual.getValue();
    
    if (saldoAtual && !this.saldoExpirado(saldoAtual.tempo)) {
      return saldoAtual;
    }
    
    try {
      return await this.obterSaldo();
    } catch (error) {
      console.error('Erro ao atualizar saldo expirado:', error);
      
      if (saldoAtual) {
        return saldoAtual;
      }
      
      return this.saldoInicial;
    }
  }

  getSaldoObservable() {
    return this.saldoAtual.asObservable();
  }
}


